
  import { mapState } from "vuex"

  export default {
    name: `AddCredits`,
    props: {},
    data() {
      return {
        loading: false,
        newCredits: undefined,
        reference: undefined,
        selectedAddress: undefined,
        addCreditsModal: false
      }
    },
    computed: {
      ...mapState({
        currency: (state) => state.accounting.settings.currency,
        invoiceModes: (state) => state.accounting.settings.invoice_mode || ``,
        addressesList: (state) => state.accounting.addressesList
      }),
      companyTag() {
        return this.$auth.user.current_company
      },
      billingAddresses() {
        return this.addressesList
          .filter((addr) => addr.type === "billing" || addr.type === "main")
          .map((addr) => ({
            ...addr,
            formatted_address: `${addr.type_description}${addr.locality?.length > 0 ? ` - ${addr.locality}` : ""}${
              addr.email?.length > 0 ? ` - ${addr.email}` : ""
            }${addr.contact?.length > 0 ? ` - ${addr.contact}` : ""}`
          }))
          .sort((a, b) => a.formatted_address.localeCompare(b.formatted_address))
      }
    },
    watch: {
      selectedAddress(newVal) {
        if (newVal) {
          const selectedAddr = this.addressesList.find((addr) => addr.uuid === newVal)
          this.reference = selectedAddr?.reference || ""
        }
      }
    },
    async fetch() {
      await this.$store.dispatch(`accounting/getSettings`, { companyTag: this.companyTag })
      await this.$store.dispatch(`accounting/getAddresses`, { companyTag: this.companyTag })
    },
    methods: {
      prefillAddress() {
        const billingOnly = this.billingAddresses.filter((addr) => addr.type === "billing")
        const mainAddress = this.billingAddresses.find((addr) => addr.type === "main")

        if (billingOnly.length === 0) {
          // No billing address: use main address
          this.selectedAddress = mainAddress?.uuid
        } else if (billingOnly.length === 1) {
          // 1 billing address: use it
          this.selectedAddress = billingOnly[0].uuid
        } else {
          // 2+ billing addresses: use first alphabetically (already sorted)
          this.selectedAddress = billingOnly[0].uuid
        }
      },
      closeModalAddCredits() {
        this.newCredits = undefined
        this.reference = undefined
        this.selectedAddress = undefined
        this.addCreditsModal = false
        this.loading = false
      },
      async addCredits() {
        const ref = this?.$refs.newCreditsModalObs
        const creditValidate = await ref?.validate()
        if (!!creditValidate) {
          try {
            this.loading = true
            const res = await this.$store.dispatch(`accounting/addCredits`, {
              amount: this.newCredits,
              reference: this.reference,
              addressUUID: this.selectedAddress
            })
            this.closeModalAddCredits()
            if (res.status === `error`) {
              throw new Error(res.msg)
            }
            await this.$store.dispatch(`accounting/getSettings`, { companyTag: this.companyTag })
            this.$store.dispatch(
              `flashMessages/messageSuccess`,
              {
                message: this.$i18n.t(
                  `pages.settings.Thank_you_your_account_has_been_charged_don_t_hesitate_to_ask_us_if_you_have_any_questions`
                )
              },
              { root: true }
            )
          } catch (error) {
            this.$store.dispatch(
              `flashMessages/messageError`,
              {
                message: error.message
              },
              { root: true }
            )
          }
        }
      },
      openModalAddCredits() {
        this.addCreditsModal = true
        this.prefillAddress()
      },
      goToManageAddresses() {
        this.$router.push(`/accounting#settings`)
        this.closeModalAddCredits()
      }
    }
  }
